require('./template.js');

Pegasus.EmailTemplate = Pegasus.Template.extend({
  fragments: [],
  underscore_type: 'email_template',
  globalSettings: DS.attr('string'),
  html: DS.attr('string'),
  openingHtmlPart: DS.attr('string'),
  userDefinedBackgroundImage: null,
  userDefinedBackgroundColor: null,
  paletteType: 'Palette',
  bodyImageType: 'BodyImage',
  supportsRowColorOpacity: false,
  blockTheme: 'tech',
  previewContent: function(_,value){
    if( typeof( value ) !== 'undefined' ){
      return value;
    }
    return '';
  }.property(),
  gallerySizeKey: 'large',
  insideHtmlPart: DS.attr('string'),
  uid: DS.attr('string'),
  maxImageWidth: 620,
  maxContentWidth: 620
});

Pegasus.EmailTemplate.FIXTURES = [];

Pegasus.EmailTemplate.reopen({
  createFromExternal: function(){
    return {
      data: {
        selectedTheme: {
          name: 'tech'
        }
      },
      model: this.store.createRecord(Pegasus.EmailTemplate)
    };
  }
});
